import React from 'react'
import classnames from 'classnames'
import S from './Button.module.css'
// import { Analytics } from '../../util'

export default class Button extends React.Component {

  onClick = ( evt ) => {
    const { disabled, /* gaKey, */ onClick } = this.props
    if ( !disabled ) {
      // if ( gaKey ) {
      //   Analytics.track( gaKey )
      // }
      if ( onClick ) {
        onClick( evt )
      }
    }
  }

  render() {
    const {
      title, children, scheme, className, disabled, /* gaKey, */ ...rest
    } = this.props
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <button {...rest} className={classnames( S.button, disabled ? S.disabled : null, S[scheme], className )} type="button" onClick={this.onClick} title={title}>
        {children}
      </button>
    )
  }
}
